import * as React from "react";
import * as moment from "moment";
import { NumberFormat } from "../../assets";

// tslint:disable-next-line:variable-name
export const DataTableRow = (props) => {
	let { config, data, isGroupHeading, styles } = props;
	return (
		<tr className={isGroupHeading ? styles.groupHeading : styles.tableRow}>
			{config.keys.map((key, index) => {
				if (key === "ipd_benchmark_as_at_date") {
					data[key] = moment(data.date).format("DD.MM.YYYY");
				}

				//Fix for MG-1247
				if (key === "neutrality" && data[key] === 0) {
					data[key] = "-";
				}

				if (index === 0) {
					return (
						<td key={index * 13}>{data[key]}</td>
					);
				} else {
					return (
						<td className={styles.numbers} key={index * 13}>
							{typeof data[key] === "string" ? data[key] : <NumberFormat options={{ precision: 1, emptyValue: "0.0" }}>{data[key]}</NumberFormat>}
						</td>
					);
				}
			})}
		</tr>
	);
};


// WEBPACK FOOTER //
// ./src/client/components/PageAllocations/DataTableRow.tsx